
import { mapMutations, mapGetters, mapActions } from 'vuex';
import SearchFormEcom from '~/components/header/SearchFormEcom';
import vClickOutside from 'v-click-outside';
import CartIcon from '@/components/svg/CartIcon';
import header from '~/mixins/header';

export default {
    mixins: [header],
    props: ['localeName'],
    components: {
        SearchFormEcom,
        CartIcon,
    },
    directives: {
        clickOutside: vClickOutside.directive,
    },
    mounted() {
        const initUserTheme = this.getTheme() || this.getMediaPreference();
        this.setTheme(initUserTheme);

        const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
        if (isSafari) {
            this.forceRepaint();
        }
    },
    data() {
        return {
            userTheme: 'light-theme',
        };
    },
    watch: {
        getModalShow: val => {
            if (val) {
                document.body.classList.add('popup-open');
                document.documentElement.classList.add('popup-open');
            } else {
                document.body.classList.remove('popup-open');
                document.documentElement.classList.remove('popup-open');
            }
        },
    },
    computed: {
        ...mapGetters('search', ['getModalShow']),
        ...mapGetters('cart', ['getProductsLength']),
        cartProductsLength() {
            return this.getProductsLength;
        },
        otherLangCode() {
            return this.$i18n.locales.filter(i => i.code !== this.$i18n.locale)[0].code;
        },
        ...mapGetters(['getShowNavigationMobile']),
        ...mapGetters({
            globalSettings: 'global/globalSettings',
            isVitrina: 'global/isVitrina',
            isOpen: 'auth/isOpen',
            isAuth: 'auth/isAuth',
            isNovaPorta: 'global/getIsNovaPorta',
            mainPhoneNumber: 'global/mainPhoneNumber',
            getCurrentTheme: 'global/getCurrentTheme',
        }),
    },
    methods: {
        ...mapMutations('search', ['setModalShow']),
        ...mapMutations(['setShowNavigationMobile']),
        ...mapActions('cart', ['openCart']),
        logout() {
            this.$store.dispatch('auth/logout');
        },
        openCall() {
            window.open(`tel:${this.mainPhoneNumber?.replace(/\s/g, '')}`, '_self');
        },
        openModalAuth() {
            this.$store.dispatch('auth/setIsOpen', true);
        },
        toggleMenu() {
            this.setShowNavigationMobile(!this.getShowNavigationMobile);
        },
        toggleThemeMobile() {
            const activeTheme = this.$cookies.get('user-theme');
            if (activeTheme === 'light-theme') {
                this.setTheme('dark-theme');
            } else {
                this.setTheme('light-theme');
            }

            this.forceRepaint();
        },
        getTheme() {
            const savedTheme = this.$cookies.get('user-theme');

            const isDarkTheme = document.body.classList.contains('dark-theme');

            if (savedTheme) {
                return savedTheme;
            } else {
                if (isDarkTheme) {
                    return 'dark-theme';
                }
                return 'light-theme';
            }
        },
        setTheme(name) {
            this.userTheme = name;

            if (name === 'light-theme') {
                document.body.classList.remove('dark-theme');
                document.body.classList.add('light-theme');
                this.$cookies.set('user-theme', 'light-theme');
            } else if (name === 'dark-theme') {
                document.body.classList.remove('light-theme');
                document.body.classList.add('dark-theme');
                this.$cookies.set('user-theme', 'dark-theme');
            }

            this.forceRepaint();
        },
        getMediaPreference() {
            const hasDarkPreference = window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches;
            if (hasDarkPreference) {
                return 'dark-theme';
            } else {
                return 'light-theme';
            }
        },

        forceRepaint() {
            document.body.style.display = 'none';
            document.body.offsetHeight;
            document.body.style.display = '';
        },

        externalClickSearch(event) {
            if (!['search__input', 'searchForm', 'search', 'update', 'showSearch'].includes(event.target.id))
                this.setModalShow(false);
        },
    },
};
